import React from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import ReactComponentHelper from '../helper/ReactComponentHelper';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
const log = new Logger('ANALYSIS_DETAILS_FORM', LOG_LEVELS.DEBUG);

class AnalysisDetails extends React.Component {

    constructor(props) {
        super(props);
        this.getColumns = this.getColumns.bind(this);
    }

    getColumns() {
        let valueVAT = 0;
        let valueExclVAT = 0;
        let reversedVAT = 0;
        if(this.props.detailsData) {
            valueVAT = this.props.detailsData.vat;
            valueExclVAT = this.props.detailsData.taxableBasis;
            reversedVAT = this.props.detailsData.vatReversed;
        }
        
        return [
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_Nr'}></LanguageStringResolver>), 
                accessor: 'nr', 
                filterable: true
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_InvoiceNumber'}></LanguageStringResolver>), 
                accessor: 'invoiceNumber', 
                filterable: true,
                Cell: (row) => {
                    const original = row && row.original;
                    if(!original) {
                        return (
                            <span></span>
                        );
                    }
                    let invoiceNumber = original.invoiceNumber;
                    let invoiceYear = '0';
                    let invoiceDate = (typeof original.invoiceDate === 'string' && original.invoiceDate) || '';
                    if(!_.isEmpty(invoiceDate) && invoiceDate.length > 9) {
                        const invoiceDate = moment.utc(original.invoiceDate.substr(0, 10), 'YYYY-MM-DD');
                        invoiceYear = (invoiceDate.isValid() && invoiceDate.format('YYYY')) || '0';
                    }
                    const linkToTransactionSearch = `/TransactionSearch?exactMatch=1&reference=${invoiceNumber}&searchType=0&year=${invoiceYear}`;
                    return (
                        <button className="link">
                            <Link to={linkToTransactionSearch}>{invoiceNumber}</Link>
                        </button>
                    );
                }
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_InvoiceDate'}></LanguageStringResolver>), 
                accessor: 'invoiceDate', 
                Cell: (row) =>  {
                    let value = row && row.value;
                    if(_.isEmpty(value) || typeof value !== 'string') {
                        return (
                            <span></span>
                        );
                    }
                    return (
                        <span>{value.substr(0, 10)}</span>
                    );
                },
                filterable: true
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_DocumentType'}></LanguageStringResolver>), 
                accessor: 'documentType', 
                filterable: true
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_SAPDocumentType'}></LanguageStringResolver>), 
                accessor: 'sapDocumentType', 
                filterable: true,
                Footer: (
                    <LanguageStringResolver className="semi-bold" string={'analysisDetails_Totals'} />
                )
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_ValueExclVAT'}></LanguageStringResolver>), 
                accessor: 'valueExclVAT', 
                filterable: true,
                ...ReactComponentHelper.getCurrencyColumnOptions(),
                Footer: (
                    <FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} value={valueExclVAT} />   
                ),
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude()
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_ValueVAT'}></LanguageStringResolver>), 
                accessor: 'valueVAT', 
                filterable: true,
                ...ReactComponentHelper.getCurrencyColumnOptions(),
                Footer: (
                    <FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} value={valueVAT} />
                ),
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude()
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_ReversedVAT'}></LanguageStringResolver>), 
                accessor: 'reversedVAT', 
                filterable: true,
                ...ReactComponentHelper.getCurrencyColumnOptions(),
                Footer: (
                    <FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} value={reversedVAT} />
                ),
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude()
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_Currency'}></LanguageStringResolver>), 
                accessor: 'currency', 
                filterable: true
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_VATCode'}></LanguageStringResolver>), 
                accessor: 'vatCode', 
                filterable: true
            },
            { 
                Header: () => (<LanguageStringResolver string={'analysisDetails_CompanyCode'}></LanguageStringResolver>), 
                accessor: 'companyCode', 
                filterable: true
            }
        ];
    }

    render () {
        log.debug('render(): ', this.props);
        const {detailsData, invoices = [], tableOptions={}, pages=-1} = this.props;
        if(!detailsData || _.isEmpty(detailsData)) {
            return (
                <span>Analysis details not found!</span>
            );
        }
        const cols = this.getColumns() || [];

        const NoDataComponent = props => (
            <NoData
              noDataText="analysisDetails_NoData"
              {...props}
            />
          )

        return (
            <div>
                <div className="mb10">
                    <span className="semi-bold mr10">
                        <LanguageStringResolver string='analysisDetails_VATCode'/>: 
                    </span>
                    <span>{detailsData.vatCode}</span>      
                </div>   
                <ReactTable
                    defaultPageSize={20}
                    minRows={0}
                    maxRows={0}
                    manual
                    pages={pages}
                    data={invoices}
                    columns={cols}
                    onFetchData={this.props.onFetchInvoices}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                    pageSizeOptions={[10, 20, 50, 100, 200, 500, 1000]}
                    loading={this.props.loading}
                    {...tableOptions}
                    NoDataComponent={NoDataComponent}
                    className={'overflow-hidden'}
                    PaginationComponent={Pagination}
                    showPagination={invoices.length === 0 ? false : true}
                />
            </div>
        );
    }
}


AnalysisDetails.defaultProps = {
    invoices: [],
    tableOptions: {},
    onFetchInvoices: () => {},
    loading: false
};

export default AnalysisDetails;
